<template>
  <div class="profile-form">
    <section>
      <div class="section-title">
        <span>Contatti</span>
      </div>
      <div class="section-body">
        <div class="input-container">
          <input v-model="email" type="mail" name="email" placeholder="Email" />
        </div>
        <div class="input-container">
          <input v-model="phone" type="text" name="phone" placeholder="Telefono" />
        </div>
        <div class="input-container">
          <input v-model="mobile" type="text" name="mobile" placeholder="Cell" />
        </div>
      </div>
    </section>
    <section>
      <div class="section-title">
        <span>Informazioni generali</span>
      </div>
      <div class="section-body">
        <div class="input-container">
          <input v-model="sede" type="text" name="sede" placeholder="Sede" />
        </div>
        <div class="input-container">
          <input v-model="address" type="text" name="address" placeholder="Indirizzo" />
        </div>
        <div class="input-container">
          <input v-model="area" type="text" name="area" placeholder="Area appartenenza" />
        </div>
        <div class="input-container">
          <input v-model="ruolo" type="text" name="ruolo" placeholder="Ruolo" />
        </div>
        <div class="input-container">
          <input v-model="birthday" type="date" name="birthday" placeholder="Data di Nascita" />
        </div>
      </div>
    </section>
    <section>
      <div v-on:tap="addSkill()" class="section-title">
        <span>Competenze</span>
        <span class="t plus">
          <img src="../assets/images/add.svg" />
        </span>
      </div>
      <div class="section-body no-color">
        <div
          class="swipe-container-util"
          v-bind:id="'skill'+skill.key"
          v-for="(skill, index) in skills"
          v-bind:key="skill.key"
          v-swipe:onSwipe="{configs:[
          { handler: removeSkill, handlerArgs:skill, endTransitionDuration: 200, remove:true },
          { handler: removeSkill,handlerArgs:skill, endTransitionDuration: 200, direction: 'right', remove:true}],}"
        >
          <div class="input-container">
            <input type="text" v-model="skills[index].value" placeholder="Skill" />
          </div>
        </div>
      </div>
    </section>
    <!-- ESPERIENZA -->
    <!-- <section>
      <div class="section-title">
        <span>Esperienze</span>
        <span v-on:tap="addExperience()" class="plus">
          <img src="../assets/images/add.svg" />
        </span>
      </div>
      <div class="section-body">
        <div class="input-container">
          <input
            v-model="experience.startDate"
            type="text"
            name="ruolo"
            placeholder="Data Inizio (Mese, anno)"
          />
        </div>
        <div class="input-container">
          <input
            v-model="experience.endDate"
            type="text"
            name="ruolo"
            placeholder="Data Fine (Mese, anno)"
          />
        </div>
        <div class="input-container">
          <input v-model="experience.ruolo" type="text" name="ruolo" placeholder="Ruolo" />
        </div>
        <div class="input-container">
          <input v-model="experience.azienda" type="text" name="azienda" placeholder="Azienda" />
        </div>
        <div class="input-container">
          <input v-model="experience.luogo" type="text" name="citta" placeholder="Citta" />
        </div>
      </div>
    </section>

    <section v-for="(exp,idx) in experiences" v-bind:key="idx">
      <div class="section-title">
        <span>Esperienze</span>
        <span v-on:tap="addExperience()" class="plus">
          <img src="../assets/images/add.svg" />
        </span>
      </div>
      <div class="section-body">
        <div class="input-container">
          <input
            v-model="experiences[idx].startDate"
            type="text"
            name="ruolo"
            placeholder="Data Inizio (Mese, anno)"
          />
        </div>
        <div class="input-container">
          <input
            v-model="experiences[idx].endDate"
            type="text"
            name="ruolo"
            placeholder="Data Fine (Mese, anno)"
          />
        </div>
        <div class="input-container">
          <input v-model="experiences[idx].ruolo" type="text" name="ruolo" placeholder="Ruolo" />
        </div>
        <div class="input-container">
          <input
            v-model="experiences[idx].azienda"
            type="text"
            name="azienda"
            placeholder="Azienda"
          />
        </div>
        <div class="input-container">
          <input v-model="experiences[idx].luogo" type="text" name="citta" placeholder="Citta" />
        </div>
      </div>
    </section>-->

    <div v-on:tap="save()" class="button">Salva</div>
  </div>
</template>
<script>
import swipe from '../directives/swipe.new';
export default {
  name: 'profile-form',
  props: ['user'],
  directives: {
    swipe
  },
  data() {
    return {
      email: this.getContact('Email'),
      phone: this.getContact('Tel. Interno'),
      mobile: this.getContact('Mobile'),
      sede: this.getInfo('Sede di Lavoro'),
      address: this.getInfo('Indirizzo'),
      area: this.getInfo('Area'),
      ruolo: this.getInfo('Ruolo'),
      birthday: this.getInfo('Data di Nascita'),
      skills: this.getSkills(),
      experience: {
        startDate: '',
        endDate: '',
        ruolo: '',
        azienda: '',
        luogo: ''
      },
      experiences: this.user.experience
    };
  },
  methods: {
    addExperience() {
      const experience = this.experience;
      const newExperience = {
        periodo: `${experience.startDate} - ${experience.endDate}`,
        startDate: experience.startDate,
        endDate: experience.endDate,
        ruolo: experience.ruolo,
        azienda: experience.azienda,
        luogo: experience.luogo
      };
      this.experiences.push(newExperience);
      this.resetExperience();
    },
    resetExperience() {
      this.experience = {
        startDate: '',
        endDate: '',
        ruolo: '',
        azienda: '',
        citta: ''
      };
    },
    save() {
      const user = this.user;
      const contacts = [
        { key: 'Email', value: this.email },
        { key: 'Tel. Interno', value: this.phone },
        { key: 'Mobile', value: this.mobile }
      ];
      const info = [
        { key: 'Sede di Lavoro', value: this.sede },
        { key: 'Indirizzo', value: this.address },
        { key: 'Area', value: this.area },
        { key: 'Ruolo', value: this.ruolo },
        { key: 'Data di Nascita', value: this.birthday }
      ];
      const skills = this.skills
        .filter(s => !!s.value && s.value !== '')
        .map(s => s.value);

      user.contacts = contacts.filter(c => c.value !== '');
      user.info = info.filter(i => i.value !== '');
      user.skills = skills;
      this.addExperience();
      // this.experiences.push(this.experience);
      const experiences = [];
      for (let index = 0; index < this.experiences.length; index++) {
        const object = this.experiences[index];
        for (const key in object) {
          if (object.hasOwnProperty(key)) {
            if (object[key] === '') {
              delete object[key];
            }
            if (key === 'periodo' && object[key] === ' - ') {
              delete object[key];
            }
          }
        }
        console.log(Object.entries(object));
        console.log(object);

        if (Object.entries(object).length) {
          experiences.push(object);
        }
      }
      user.experience = experiences;

      this.$emit('profileSaved', user);
    },
    getSkills() {
      return this.user.skills.map(s => {
        return { key: this.assignSkillId(), value: s };
      });
    },
    getContact(k) {
      let contact = this.user.contacts.find(c => c.key === k);
      return contact && contact.value ? contact.value : '';
    },
    getInfo(k) {
      let info = this.user.info.find(c => c.key === k);
      return info && info.value ? info.value : '';
    },
    addSkill() {
      console.log(this.skills);

      this.skills.push({ key: this.assignSkillId() });
    },
    assignSkillId() {
      return skillId++;
    },
    removeSkill(skill) {
      console.log(`REMOVE SKILL `, skill);
      const idx = this.skills.findIndex(s => s.key === skill.key);
      // const idx = this.skills.indexOf(skill);
      if (idx !== -1) {
        this.skills.splice(idx, 1);
      } else {
        console.log('falso positivo');
      }
    }
  }
};
let skillId = 0;
</script>
<style lang="scss" scoped>
input {
  border: none;
  width: 100%;
  letter-spacing: 1px;
  &::placeholder {
    color: #607d8b;
  }
}
.profile-form {
  padding: 21px;
  letter-spacing: $default-letter-spacing;
  background-color: #f7f7f7;
  margin-bottom: 50px;
}
section {
  margin-bottom: 20px;
  .section-title {
    display: flex;
    font-weight: 600;
    margin-bottom: 10px;
    background-color: #ffffff;
    border-radius: $default-border-radius;
    padding: 18px;
    align-items: center;
    justify-content: space-between;
  }
  .section-body {
    border-radius: $default-border-radius;
    background-color: #ffffff;
    letter-spacing: 1px;
    &.no-color {
      background-color: transparent;
    }
    .swipe-container-util {
      background-color: #ffffff;
    }
    .input-container {
      font-size: 0.95em;
      border: #0000000d solid 1px;
      padding: 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: all 0.1s;
    }
  }
  .plus,
  .minus {
    display: flex;
  }
}
.button {
  background-color: #a31313;
  padding: 18px;
  text-align: center;
  color: #ffffff;
  border-radius: $default-border-radius;
}

/* Always display the drop down caret */
input[type='date']::-webkit-calendar-picker-indicator {
  color: #2c3e50;
  background: white;
}

/* A few custom styles for date inputs */
input[type='date'] {
  appearance: none;
  -webkit-appearance: none;
  border: none;
  background: white;
  padding: 5px;
  display: inline-block !important;
  visibility: visible !important;
}

input[type='date'],
focus {
  box-shadow: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
}
</style>
